import { getVideoPath } from '@/utils/videos';
import { STUDIO_WHITE_LABEL_FEATURE } from '@/constants/accountFeatures';
import { useBillingContext } from '@/features/billing/components/BillingContext';
import { useAccountFeatures } from '@/components/studio/hooks/useAccountFeatures';
import { StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';

export const useGetVideoPath = (video: StudioVideo) => {
  const { data } = useAccountFeatures();
  const { isProPlan } = useBillingContext();

  const whiteLabelFeature = data?.[STUDIO_WHITE_LABEL_FEATURE];
  const hideVideoWatermark = whiteLabelFeature?.enabled && whiteLabelFeature?.settings?.hideVideoWatermark;

  const shouldRemoveWatermark = isProPlan || hideVideoWatermark;
  /** we store oroginal file in input bucket for StudioVideo and in lambda put a copy into output bucket after post processing  e.g. chaging quality*/
  return getVideoPath({ video, shouldRemoveWatermark, s3Bucket: isProPlan && video.vodAsset ? 'input' : 'output' });
};
